var check = true;
(function() {
  $(document).ready(function() {
    $(document).on("click",".swell-referral-form-list-submit", function(){
      temp_email = $('#swell-referral-refer-emails').val();
    });
    $(document).on("click", ".swell-share-referral-copy", function() {
      setTimeout(function(){
        detachReferralCopy();
        $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html().replace("http://",""));
      },20);
    });
    $('body').on('click', '.swell-referral-back-link.checkout', function(e){
      $(".fuse-lenses-rewards").hide();
    });
    $('body').on('click', '.swell-referral-back-link', function(e){
      $(".swell-referral").removeClass("thankyou");
      $(".swell-referral-sidebar-details").show();
    });
    if(check){
      initialize_swell();
      check = false;
    }
  });
  if(window.location.href.indexOf("orders")>0){
    initialize_swell();
    check = false;
  }
}).call(this);

function initialize_swell(){
  $(document).on("swell:setup", function() {
    if($(".campaigns").length>0){
      Swell.Campaign.initializeCampaigns(".campaigns", SwellConfig.Campaign.opts);
      $(".campaigns").append("<li class=\"swell-campaign refer\"> <div class=\"image\"></div><div class=\"text-section\"><h3>Refer A Friend</h3><p>Refer A Friend And Get $15</p><a href=\"/pages/refer\">Start Referring Now</a></div> </li>");
    }
    if($(".swell-tier-table").length>0){
      SwellConfig.Tier.initializeDummyTier();
      SwellConfig.Tier.initializeCustomTierProperties();
      SwellConfig.Tier.initializeTiers(".swell-tier-table.mobile");
      SwellConfig.Tier.initializeTiers(".swell-tier-table.desktop");
      setupSlickSlider();
    }
    if($(".swell-referral").length>0)
    {
      SwellConfig.Referral.initializeReferral(".swell-referral");      
    }
  
    if(spapi.authenticated || (spapi.customer.referral_receipts && spapi.customer.referral_receipts.length > 0)) {
      setupReferrals();
      accountPoints(); //Points that show next to account icon
    }
    $(".inner-holder").css("display","flex");
    $(document).on("swell:referral:success", function(jqXHR, textStatus, errorThrown) {
      thankyou();
    });

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
      if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
        $(".refer-customer-error").remove();
        $(".swell-referral-sidebar-details").show();
        $(".swell-referral").removeClass("thankyou");
        $(".swell-referral-content-container").addClass("error-message");
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
        $("#swell-referral-refer-emails").addClass("error-border");
      }
      else if(textStatus && textStatus === "Please enter a valid email address"){
        $(".refer-customer-error").remove();
        $(".swell-referral-sidebar-details").show();
        $(".swell-referral").removeClass("thankyou");
        $(".swell-referral-content-container").addClass("error-message");
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
        $("#swell-referral-refer-emails").addClass("error-border");
      }
    });

    $('body').on('click', '.swell-referral-copy', function(e){
      if($(e.target).hasClass("swell-referral-copy")) {
        e.stopPropagation();
      }
    });
    $(".swell-loader1, .swell-loader2").hide();
    $(".fuse-lenses-rewards").css("display","flex");
  });
}

// campaigns
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: "<li class='swell-campaign'> <div class='swell-campaign-content' data-display-mode='modal' data-campaign-id='<%=campaign.id %>'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> <i class='<%=campaign.icon %>'><span class='path1'></span><span class='path2'></span><span class='path3'></span><span class='path4'></span></i> </span> </div> <div class='swell-campaign-value'> <span class='swell-campaign-value-content'><%=campaign.reward_text %></span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-type-content'><%=campaign.title %></span> </div> <div class=\"overlay\"><div class=\"banner-buttons\"> <a class=\"swell-button signup\" href=\"/account/register\">JOIN</a> <a class=\"swell-button login\" href=\"/account/login\">LOGIN</a> </div></div> </div> </li>"
      }
    }
  };
}).call(this);

// tiers
(function() {
  
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
      
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "Level 1",
        points: "(Spend $0 - 199 per year)",
        multiplier: "<span>1x</span> Points Multiplier",
        spent: "",
        shipping: "<span class='locked'>Free Standard Domestic Shipping</span>",
        early_access: "Early Access to Sales",
        limited_lens: "",
        new_lens: ""
      });
    },
    initializeCustomTierProperties: function() {
      if(spapi.activeVipTiers.length<=1)
      {
        spapi.activeVipTiers = [
          {
            id: -1,
            rank: 0,
            name: "Level 1",
            points: "(Spend $0 - 199 per year)",
            multiplier: "<span>1x</span> Points Multiplier",
            spent: "",
            shipping: "<span class='locked'>Free Standard Domestic Shipping</span>",
            early_access: "Early Access to Sales",
            limited_lens: "",
            new_lens: ""
          },
          {
            id: 1498,
            rank: 1,
            name: "Level 2",
            points: "(Spend $200 - 299 per year)",
            multiplier: "<span>1.5x</span> Points Multiplier",
            spent: "(15 points per dollar spent)",
            shipping: "Free Standard Domestic Shipping",
            early_access: "Early Access to Sales",
            limited_lens: "Access to Special Limited Lens Colors",
            new_lens: "",
            amount_spent_cents: 20000
          },
          {
            id: 1557,
            rank: 2,
            name: "Level 3",
            points: "(Spend $300+ per year)",
            multiplier: "<span>2x</span> Points Multiplier",
            spent: "(20 points per dollar spent)",
            shipping: "Free Standard Domestic Shipping",
            early_access: "Early Access to Sales",
            limited_lens: "Access to Special Limited Lens Colors",
            new_lens: "Early Access to New Lenses",
            amount_spent_cents: 30000
          }
        ]
      }
      else
      {
        spapi.activeVipTiers[0].points = "(Spend $0 - "+((spapi.activeVipTiers[1].amount_spent_cents/100)-1)+" per year)",
        spapi.activeVipTiers[0].multiplier = "<i class='fi-trophy'></i><span>1x</span> Points Multiplier",
        spapi.activeVipTiers[0].spent = "",
        spapi.activeVipTiers[0].shipping = "<i class='fi-map locked'></i><span class='locked'>Free Standard Domestic Shipping</span>",
        spapi.activeVipTiers[0].early_access = "<i class='fi-clock'></i>Early Access to Sales",
        spapi.activeVipTiers[0].limited_lens = "<i class='fi-unlock locked'></i><span class='locked'>Access to Special Limited Lens Colors</span>",
        spapi.activeVipTiers[0].new_lens = "<i class='fi-unlock locked'></i><span class='locked'>Early Access to New Lenses</span>",

        spapi.activeVipTiers[1].points = "(Spend $"+(spapi.activeVipTiers[1].amount_spent_cents/100)+" - "+((spapi.activeVipTiers[2].amount_spent_cents/100)-1)+" per year)",
        spapi.activeVipTiers[1].multiplier = "<i class='fi-trophy'></i><span>"+spapi.activeVipTiers[1].points_multiplier+"x</span> Points Multiplier",
        spapi.activeVipTiers[1].spent = "(15 points per dollar spent)",
        spapi.activeVipTiers[1].shipping = "<i class='fi-map'></i>Free Standard Domestic Shipping",
        spapi.activeVipTiers[1].early_access = "<i class='fi-clock'></i>Early Access to Sales",
        spapi.activeVipTiers[1].limited_lens = "<i class='fi-unlock'></i>Access to Special Limited Lens Colors",
        spapi.activeVipTiers[1].new_lens = "<i class='fi-unlock locked'></i><span class='locked'>Early Access to New Lenses</span>",

        spapi.activeVipTiers[2].points = "(Spend $"+(spapi.activeVipTiers[2].amount_spent_cents/100)+"+ per year)",
        spapi.activeVipTiers[2].multiplier = "<i class='fi-trophy'></i><span>"+spapi.activeVipTiers[2].points_multiplier.split(".")[0]+"x</span> Points Multiplier",
        spapi.activeVipTiers[2].spent = "(20 points per dollar spent)",
        spapi.activeVipTiers[2].shipping = "<i class='fi-map'></i>Free Standard Domestic Shipping",
        spapi.activeVipTiers[2].early_access = "<i class='fi-clock'></i>Early Access to Sales",
        spapi.activeVipTiers[2].limited_lens = "<i class='fi-unlock'></i>Access to Special Limited Lens Colors",
        spapi.activeVipTiers[2].new_lens = "<i class='fi-unlock'></i>Early Access to New Lenses"
      }
    },
    initializeTiers: function(containerSelector) {
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      var next_info = "";
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      if(customer_tier_rank == null){
        customer_tier_rank = 0;
      }

      for(var t=0;t<tiers.length;t++) {
        if (t==customer_tier_rank && spapi.authenticated) {
          tiers[t].current_status="Current Status";
          var amountCustomerSpent = spapi.customer.vip_tier_stats.amount_spent_cents === undefined ? 0 : spapi.customer.vip_tier_stats.amount_spent_cents;
          $("#tierProgress").empty();
          if (t+1 > tiers.length) {
          } else {
            $("#tierProgress").append("<p>Spend <span>$" 
                                      + (tiers[t+1].amount_spent_cents - amountCustomerSpent)/100 
                                      + "</span> to unlock next tier</p><div class='progress-shell'><div class='actual-progress' style='width:" 
                                      + (amountCustomerSpent /tiers[t+1].amount_spent_cents)*100
                                      +"%;'></div></div><p class='multiplier'>Earn "+tiers[t+1].points_multiplier +"x pts</p>"
            );
          }
        } else {
          tiers[t].current_status="";
        }
      }
      // $(containerSelector).append("<li class='titles-col'><span class='current-status-item'></span><span class='benefits-item'></span><span class='points-item'></span><span class='multiplier-item'>points multiplier</span><span class='birthday-points-item'>birthday points</span><span class='rewards-shop-item'>access to rewards shop</span><span class='free-shipping-item'>free shipping</span><span class='early-access-item'>early access to products</span><span class='birthday-gift-item'>birthday gift</span><span class='gift-card-item'>gift card</span></li>");
      $(containerSelector).append("<li class='tier-holder'></li>");
      for(var t=0;t<tiers.length;t++) {
        if (t==customer_tier_rank && spapi.authenticated) {
          $(".tier-holder").append("<div class='tier-"+(t+1)+"-col active'><span class='current-status-item'>"+tiers[t].current_status+"</span><span class='benefits-item'>"+tiers[t].name+"</span><span class='points-item'>"+tiers[t].points+"</span><span class='multiplier-item'>"+tiers[t].multiplier+"</span><span class='spent-item'>"+tiers[t].spent+"</span><span class='early-access-item'>"+tiers[t].early_access+"</span><span class='shipping-item'>"+tiers[t].shipping+"</span><span class='limited-lens-item'>"+tiers[t].limited_lens+"</span><span class='new-lens-item'>"+tiers[t].new_lens+"</span></div>");
          if (t<2){
            next_info = "Spend $"+((tiers[t+1].amount_spent_cents - spapi.customer.vip_tier_stats.amount_spent_cents)/100)+" more to unlock "+tiers[t+1].name;
  
          } 
        } else {
          $(".tier-holder").append("<div class='tier-"+(t+1)+"-col'><span class='next-info-item'>"+next_info+"</span><span class='current-status-item'></span><span class='benefits-item'>"+tiers[t].name+"</span><span class='points-item'>"+tiers[t].points+"</span><span class='multiplier-item'>"+tiers[t].multiplier+"</span><span class='spent-item'>"+tiers[t].spent+"</span><span class='early-access-item'>"+tiers[t].early_access+"</span><span class='shipping-item'>"+tiers[t].shipping+"</span><span class='limited-lens-item'>"+tiers[t].limited_lens+"</span><span class='new-lens-item'>"+tiers[t].new_lens+"</span></div>");
          next_info = "";
        }
      }
    }
  }
}).call(this);

function setupSlickSlider(){
  $('.swell-tier-table.mobile .tier-holder').slick({
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true
  });
  $('.swell-tier-table.desktop .tier-holder').slick({
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false
  });
}


// referral
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "REFER A FRIEND",
        referralSidebarDetailsReward: "",

        referralRegisterHeading: "GIVE $15, GET $15",
        referralRegisterFormDetails: "Enter your email to get started.",
        referralRegisterFormEmail: "Enter your email",
        referralRegisterFormSubmit: "NEXT",
        referralRegisterDetails: "Give your friends $15 off on their first purchase of any lens and get $15 for each successful referral!",

        referralReferHeading: "GIVE $15, GET $15",
        referralReferFormEmails: "your friends' email (seperated by commas)",
        referralReferFormSubmit: "SEND",
        referralReferFormDetails: "Now, enter you friend's email below.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "Give your friends $15 off on their first purchase of any lens and get $15 for each successful referral!",

        referralReferMediaDetails: "You can also share your link with<br class='mobile'> the buttons below.",

        referralShareFacebook: "Share",
        referralShareCopy: "Copy Link",
        referralShareSMS: "SMS",
        referralShareMessenger: "Message",

        referralFacebookIcon: "swell-icon-facebook1",
        referralLinkIcon: "swell-icon-link",
        referralSMSIcon: "swell-icon-sms",
        referralMessengerIcon: "swell-icon-message",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "Copy Link",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends"
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <div class="swell-referral-details-container"><p class="swell-referral-details"><%= localization.referralRegisterDetails %></p></div><div class="middle-border"></div><div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" class="swell-referral-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-button"> <div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </div> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <div class="swell-referral-details-container"><p class="swell-referral-details"><%= localization.referralReferDetails %></p></div><div class="middle-border"></div><div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> <span class="swell-referral-form-field-details"><%= localization.referralReferFormEmailsDetails %></span> </li> <li class="swell-referral-form-list-button"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-sms" aria-hidden="true"></i>&nbsp;SMS </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareMessenger %> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareCopy %> </div> </li> </ul> </div> </div>'
      }
    },
    initializeReferral: function(containerSelector) {
      var email = $(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      $(".swell-referral").show();
    }
  };
}).call(this);

function setupReferrals (){
  $(".swell-referral-content").show();
  $(".border").show();
  if(spapi.customer.referral_receipts.length > 0) {
    $(".referral-table").show();

    referrals = spapi.customer.referral_receipts;

    referrals.forEach(function(referral) {
      status = null;

      if(referral.completed_at){ 
        status = "Purchased ($15 earned)";
      } else {
        status = "Invited";
      }

      $(".swell-referral-table tbody").append('<tr> <td> <div class="trucate-email">' +  referral.email + '</div></td><td>' + status +'</td></tr>');
    });  
  }
}

function detachReferralCopy(){
  if($(".swell-referral-copy").length > 0){
    $("body").append($(".swell-referral-copy").detach());
    $(".swell-referral-copy-content").css("margin","0");
  }
}

function thankyou(){
  $(".swell-referral-sidebar-details").hide();
  $(".swell-referral").addClass("thankyou");
  if($(".swell-referral-table").length>0)
  {
    $(".swell-referral-table tbody").append("<tr><td>"+temp_email+"</td><td>Invited</td></tr>");
  }
}

function accountPoints() {
	if(spapi.customer.points_balance){
    	$('#yourPoints').empty();
        $('#yourPoints').append("<span>"+ spapi.customer.points_balance +"pts</span>");
    }
}
